//imports
import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate, useParams, Routes, Route, Navigate, useSearchParams } from "react-router-dom";

//controls
import { Loading } from "Components";
import { importExternalScript } from "Core/hooks";
import { ValidateVersion, GerVersionFromServer } from "Core/security";
import { ErrorHandlerLogin } from 'Core/data/Helpers';
import SalesForceApi from 'Core/salesForceApi';
//sass  432
import "./login.scss";

//actions
import {
  getResellerInfo,
  getLoginPage,
  termsAndCondition,
} from "Redux/actions";

import ContentLogin from "./components/ContentLogin";
import FormLogin from "./components/FormLogin";
import TermsAndCondition from "./components/TermsAndCondition";
import { loginWithPM, reset } from "./redux/slice";

const LoginView = () => {

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [newLoginPage, setNewLoginPage] = useState(false);
  const [credentials, setCredentials] = useState({});
  const [termsAndConditionPage, setTermsAndConditionPage] = useState(false);


  //import script for statuspage
  importExternalScript("https://gjw3kv7rh8bd.statuspage.io/embed/script.js");

  ///selectors
  const lang = useSelector(state => state.commomRedux.language);
  const { loadingLoginPage, loginPage, error, termAndConditionData } = useSelector((state) => state.loginRedux);
  // reseller config
  const { current_reseller, reseller_was_validated } = useSelector((state) => state.resellerRedux);

  // if reseller is comming by parameter
  let { reseller } = useParams();

  useEffect(() => {
    // Check for new version on login page load and reload if a newer build is available
    GerVersionFromServer(() => { ValidateVersion("login"); });

    //end cleanup
    return () => {
      // clear login redux
      dispatch(reset())
      setNewLoginPage(false);
    };
  }, []);

  //error handling for terms and condition
  useEffect(() => {
    if (error && ErrorHandlerLogin(error) == 'login_invalid_terms_condition') {
      setTermsAndConditionPage(true)
    }
  }, [error]);


  //terms and condition data effect
  useEffect(() => {
    if (termAndConditionData?.username) {
      setCredentials({ username: termAndConditionData?.username, password: termAndConditionData?.password, authId: termAndConditionData.authId })

      dispatch(reset({ termAndConditionData: {} }))
    } 
  }, [termAndConditionData]);

  //change language effect
  useEffect(() => {
    let language = lang === 'en' ? 'EN' : 'ES'
    if (!loginPage || newLoginPage) {
      dispatch(getLoginPage({ fileKey: `${language}-gpstrackit.htm`, preview: false, language, navigate }));
    }
    setNewLoginPage(true)
  }, [lang]);

  //reseller effect
  useEffect(() => {
    if (reseller) {
      //// checking reseller by key and by name in the url
      dispatch(getResellerInfo("key", reseller));
    } else if (!current_reseller) {
      // check if the current domain corresponds to a reseller
      const hostname = window.location.hostname;
      dispatch(getResellerInfo("domain", hostname));
    }
  }, [reseller]);


  const callback = (username, password, authId) => {
    setCredentials({ username, password, authId })
  }

  const sendTermsAndCondition = () => {
    dispatch(termsAndCondition({ username: credentials?.username, password: credentials?.password, navigate, authId: credentials?.authId }));
  }

  const handleClose = () => {
    navigate('/')
    setTermsAndConditionPage(false)
  }

  return (
    <>
      {
        loadingLoginPage ? (
          <div className="loading-area" style={{ height: "100%" }}>
            <Loading full />
          </div>
        ) : (
          <ContentLogin
            loginPage={loginPage}
            current_reseller={current_reseller}
            reseller_was_validated={reseller_was_validated}
          >
            {
              termsAndConditionPage &&
              <TermsAndCondition sendTermsAndCondition={sendTermsAndCondition} callback={handleClose} />
            }

            {
              !termsAndConditionPage &&
              <FormLogin
                navigate={navigate}
                current_reseller={current_reseller}
                reseller_was_validated={reseller_was_validated}
                callback={callback}
              />
            }

            {
              !current_reseller && reseller_was_validated &&
              <SalesForceApi />
            }
          </ContentLogin>
        )}
    </>
  );
};

const LoginPM = () => {

  const navigate = useNavigate()
  const dispatch = useDispatch();
  const [searchParams, setSearchParams] = useSearchParams();
  const username = searchParams.get('username')
  const token = searchParams.get('token')

  useEffect(() => {
    dispatch(loginWithPM({ username, token, navigate }));
  }, [])

  return (
    <div className="loading-area" style={{ height: "100%" }}>
      <Loading full />
    </div>
  )
}

//Router for login with PM
const LoginPreview = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch();

  const lang = useSelector(state => state.commomRedux.language);
  let { id } = useParams();

  let language = lang === 'en' ? 'EN' : 'ES'

  useEffect(() => {
    dispatch(getLoginPage({ fileKey: `${id}.htm`, preview: true, language, navigate }));
  }, [])

  return (
    <div className="loading-area" style={{ height: "100%" }}>
      <Loading full />
    </div>
  )
}

const LoginRouter = () => {

  return (
    <Routes>
      <Route path='pm' element={<LoginPM />} />
      <Route path='preview/:id' element={<LoginPreview />} />
      <Route path="/" element={<LoginView />} />
      <Route path="*" element={<Navigate to="/error" />} />
    </Routes>
  )
}

export default LoginRouter;
